var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18290_74585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8ZM5.88438 4.59688C5.64687 4.72813 5.5 4.98125 5.5 5.25V10.75C5.5 11.0219 5.64687 11.2719 5.88438 11.4031C6.12188 11.5344 6.40938 11.5312 6.64375 11.3875L11.1438 8.6375C11.3656 8.5 11.5031 8.25937 11.5031 7.99687C11.5031 7.73438 11.3656 7.49375 11.1438 7.35625L6.64375 4.60625C6.4125 4.46562 6.12188 4.45937 5.88438 4.59062V4.59688Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18290_74585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play-circle-icon.8017ec1857e4fdc1c49e2434f0e65f89.svg";
export { ForwardRef as ReactComponent };